export const DEFAULT_POLICIES_TYPES = {
    'POLICY-007': [
        {
            code: 'all',
            name: 'No profiles',
        },
        {
            code: 'org',
            name: 'Personal profile only',
        },
    ],
};

export const ADDITIONAL_POLICY_INFO = {
    'POLICY-007':
        'Non-admin users will be allowed to export items from which profile:',
};
